export const COMPANIES_INITIAL_STATE = {
  companies: [],
};

const FETCH_COMPANIES = "FETCH_COMPANIES";

export function fetchCompanies(companies) {
  return {
    type: FETCH_COMPANIES,
    payload: companies,
  };
}

export default function companiesReducer(
  state = COMPANIES_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_COMPANIES:
      return {
        ...state,
        companies: payload,
      };
    default:
      return state;
  }
}
